import React from "react";
import { FileUploader } from "react-drag-drop-files";
import { Button } from "reactstrap";
import { convertBase64 } from "../../utils";

const DragAndDropUpload = ({ multiple = true, handleChange }) => {
  const handleFileChange = files => {
    let uploadedFiles = [];
    Object.values(files).forEach(async(file, index) => {
        if(file !== Object.values(files).length){
            const convertedFile = await convertBase64(file);
            uploadedFiles = [...uploadedFiles,
              {
                fileContents: convertedFile,
                fileName: file.name,
                id: -1,
              },
            ];
            if(index === Object.values(files).length - 1){
                handleChange(uploadedFiles);
            }
        } 
    });
  };
  return (
    <FileUploader
      multiple={multiple}
      handleChange={handleFileChange}
      types={["png", "jpeg", "jpg"]}
      maxSize={5}
      children={
        <div className="drag-and-drop-uploader">
          <i
            className="fa fa-cloud-upload text-primary"
            style={{ fontSize: "36px" }}
            aria-hidden="true"
          ></i>
          <div className="mb-h font-lg">Drag & Drop your files here</div>
          <div className="mb-h font-lg">OR</div>
          <Button className="btn bg-primary py-h px-2">Browse Files</Button>
        </div>
      }
    />
  );
};

export default DragAndDropUpload;
